import {trackEvent} from "../utils/plausible";

export function componentLikes() {
    Alpine.store('like_modal', false);
    Alpine.data('likes', () => ({
        is_thumbsdown: false,
        is_thumbsup: false,
        action: false,
        title: false,

        trigger_likes: {
            ["@click"](e) {
                this.action = e.currentTarget.dataset.action;
                let plausible_vote = null;

                if (this.action === 'thumbs-up') {
                    this.is_thumbsup = true;
                    this.is_thumbsdown = false;
                    plausible_vote = 'up'
                }

                if (this.action === 'thumbs-down') {
                    this.is_thumbsup = false;
                    this.is_thumbsdown = true;
                    plausible_vote = 'down'
                }

                trackEvent('Feedback', {
                    props: {
                        vote: plausible_vote,
                        title: e.currentTarget.dataset.title,
                        type: e.currentTarget.dataset.type,
                    }
                })

                this.$store.like_modal = true;
            }
        },

        modal: {
            ["x-show"]() {
                return this.$store.like_modal
            },
            ["x-on:keydown.escape.prevent.stop"]() {
                this.$store.like_modal = false
            },
        },

        overlay: {
            ["x-show"]() {
                return this.$store.like_modal
            }
        },

        panel: {
            ["x-show"]() {
                return this.$store.like_modal
            }
        },

        action_header: {
            ["x-text"]() {
                return (this.action === 'thumbs-up') ? AlpineI18n.t('header_thumb_up') : AlpineI18n.t('header_thumb_down')
            }
        }
    }))

    Alpine.data('feedbackForm', () => ({

        formLoading: false,
        formSent: false,

        async submitForm(e) {
            let formData = new FormData(e.currentTarget)
            formData.append('action', 'send_feedback')

            this.formLoading = true;

            await fetch(site_objects.ajax_url, {
                method: "POST",
                body: formData
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.success === true) {
                        this.formSent = true

                        trackEvent('Feedback Comment', {
                            props: {
                                type: res.data.post_type,
                                title: res.data.post_title
                            }
                        })
                    }
                }).catch((error) => {
                    this.formSent = false
                }).finally(() => {
                    this.formLoading = false;
                    setTimeout(() => this.$store.like_modal = false, 1500)
                })
        }
    }))
}